import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom';
import HeaderMain from './HeaderMain';
import FooterMain from './FooterMain';

class Content extends Component {
    state = {}

    componentDidMount() {
        window.$(window).on("load", function () {
            /* Page Scroll to id fn call */
            window.$("#provider-grid a,a[href='#top'],a[rel='m_PageScroll2id']").mPageScroll2id({
                highlightSelector: "#provider-grid a"
            });

            /* demo functions */
            window.$("a[rel='next']").click(function (e) {
                e.preventDefault();
                var to = window.$(this).parent().parent("section").next().attr("id");
                window.$.mPageScroll2id("scrollTo", to);
            });
        });
    }

    render() {
        return (
            <div>
                <div className="banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10">
                                <div className="banner-content text-left text-white apps">
                                    <h1>The Future of<br /> Relocation is Here NOW!</h1>
                                    <p>
                                        Make more $$, Save $$, Find Professional Helpers, Reduce claims, and
                                        <br />
                                        many more features, built by drivers like YOU!
                                    </p>
                                    <div className="banner-btn-group p-t-20">
                                        <div>
                                            <Link to="/registration-claimrepair" className="join-btn bg-red m-r-15">Join For FREE</Link>
                                        </div>
                                        <div>
                                            <a href="#" className="p-r-15"><img src="assets/images/Apple_AppStore_White.svg" /></a>
                                            <a href="#"><img src="assets/images/google-play-banner.png" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="home-section1 text-center p-t-60 p-b-60">
                    <div className="container">
                        <div className="row">
                            <h2 className="m-0 text-center common-title text-semi-bold p-b-10 text-capitalize">What if finding helpers and shipments was easy?</h2>
                            <p className="m-0 text-center common-paragraph p-b-40">Our app makes it EASY to do your job, Maximize your Revenue, and save $1,000's</p>
                            <div className="grid-container">
                                <div className="col-md-4">
                                    <div className="home-section1-grid">
                                        <i><img src="assets/images/icons/blue/search.svg" width="60" /></i>
                                        <h5>Instantly Find Pros</h5>
                                        <p>Search through our huge database of professional packers & helpers.<br />
                                            Book, pay and rate Pros from our App.

                                    </p>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="home-section1-grid">
                                        <i><img src="assets/images/icons/blue/bars.svg" width="60" /></i>
                                        <h5>Make MORE $$</h5>
                                        <p>
                                            Easily find jobs and shipments. <br />
                                            Assist customers, companies and others drivers with side
                                            jobs while  you wait for your next shipment.
                                    </p>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="home-section1-grid">
                                        <i><img src="assets/images/icons/blue/dollar.svg" width="60" /></i>
                                        <h5>Save $$$</h5>
                                        <p>
                                            Our CYA (Cover-Your-@ssets) feature reduces
                                        your claims by up to 90%!<br />
                                            <span>Save Big $$$ On :</span><br />
                                            Hotels, Packing Materials, Truck Rentals,
                                            Fuel, Bookkeeping and every product and service you need
                                            to get the job done right.
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="home-section2">
                    <div className="home-section2-overlay">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center text-white">
                                    <h2 className="m-0 text-center p-b-10 f-s-35 text-semi-bold">How MyReloPro Works</h2>
                                    <p className="m-0 text-center common-paragraph p-b-40">
                                        Too many features to list. Here's just a couple of the ways
                                        that we make relocation EASY, MAKE you $$$, and help SAVE you some $$$.
                                    </p>
                                </div>
                            </div>
                            <div className="how-relodriver-works">

                                <div className="home-section2-content text-white text-right p-t-50">
                                    <div className="media p-b-50">
                                        <div className="media-body p-r-20">
                                            <h5 className="m-0 p-b-10">Find and book side jobs</h5>
                                            <p>
                                                <span className="m-b-5 show">- Help DITY customers, moving companies and other drivers.</span>
                                                <span className="m-b-5 show">- Forget about hunting for work.</span>
                                                <span className="show">- <b>Let the jobs come to you</b></span>
                                            </p>
                                        </div>
                                        <div className="media-right">
                                            <div className="circle-shape bg-red">
                                                <i><img src="assets/images/icons/white/briefcase.svg" width="30" /></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="media p-b-60">
                                        <div className="media-body p-r-20">
                                            <h5 className="m-0 p-b-10">
                                                Book and Pay Pros
                                            </h5>
                                            <p>
                                                <span className="m-b-5 show">- Choose from hundreds of professional helpers.</span>
                                                <span className="m-b-5 show">- Book & pay helpers from within in the app to get the job done.</span>
                                            </p>
                                        </div>
                                        <div className="media-right">
                                            <div className="circle-shape bg-red">
                                                <i><img src="assets/images/icons/white/engineer.svg" width="30" /></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="media">
                                        <div className="media-body p-r-20">
                                            <h5 className="m-0 p-b-10">Reduce your claims</h5>
                                            <p>
                                                <span className="m-b-5 show">- Dramatically lower your liability costs.<br />Reduce your claims by 90% (on average) with our unique CYA feature.</span>
                                                <span className="m-b-5 show">- Unwarranted claims are a thing of the past.</span>
                                            </p>
                                        </div>
                                        <div className="media-right">
                                            <div className="circle-shape bg-red">
                                                <i><img src="assets/images/icons/white/hand.svg" width="30" /></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="home-section2-picture mobile item">
                                    <img src="assets/images/mobile.png" alt="" className="hidden-md" />
                                    <img src="assets/images/mobile-big.png" alt="" className="hidden-lg" />
                                </div>

                                <div className="home-section2-content text-white text-left p-t-50">

                                    <div className="media p-b-50">
                                        <div className="media-left">
                                            <div className="circle-shape bg-red">
                                                <i><img src="assets/images/icons/white/group.svg" width="30" /></i>
                                            </div>
                                        </div>
                                        <div className="media-body p-l-20">
                                            <h5 className="m-0 p-b-10">
                                                Chat with customers and other professionals
                                            </h5>
                                            <p>
                                                <span className="m-b-5 show">- Chat with your team to stay organized.</span>
                                                <span className="m-b-5 show">- Keep customers in the loop.</span>
                                                <span className="m-b-5 show">- Connect with the other helper, drivers & companies to seize new <b>opportunities</b>.</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="media p-b-50">
                                        <div className="media-left">
                                            <div className="circle-shape bg-red">
                                                <i><img src="assets/images/icons/white/small-calendar.svg" width="30" /></i>
                                            </div>
                                        </div>
                                        <div className="media-body p-l-20">
                                            <h5 className="m-0 p-b-10">
                                                Manage your
                                                job Schedule
                                            </h5>
                                            <p>
                                                <span className="m-b-5 show">- Manage your Schedule smoothly within the App.</span>
                                                <span className="m-b-5 show">- Add jobs (Even those booked outside of MyReloPro) to your Schedule and organize your jobs and team.</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="media">
                                        <div className="media-left">
                                            <div className="circle-shape bg-red">
                                                <i><img src="assets/images/icons/white/settings.svg" width="30" /></i>
                                            </div>
                                        </div>
                                        <div className="media-body p-l-20">
                                            <h5 className="m-0 p-b-10">
                                                Save thousands with exclusive discounts</h5>
                                            <p>
                                                We have arranged discounts for over 1,000 products and services you frequently use:
                                               <span className="m-b-5 show">- Hotels.</span>
                                                <span className="m-b-5 show">- Truck Rentals.</span>
                                                <span className="m-b-5 show">- Fuel and more.</span>
                                            </p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </section>

                <section className="home-section3 p-t-60 p-b-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="m-0 text-center p-b-10 f-s-35 text-semi-bold hide">Why ReloPro</h2>
                                <p className="m-0 text-center common-paragraph p-b-40 text-semi-bold">
                                    We connect the LARGEST network of Moving Companies, ReloHelpers,
                                    Customers and other ReloPros to ensure you get the job done right.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-md-3">
                                <div className="home-section3-grid text-center">
                                    <div className="malibu-border circle">
                                        <i><img src="assets/images/icons/delivery.svg" width="60" /></i>
                                    </div>
                                    <h2 className="">2127</h2>
                                    <p>
                                        Moving Companies<br />
                                        Registered
                                    </p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <div className="home-section3-grid text-center">
                                    <div className="deep-lilac-border circle">
                                        <i><img src="assets/images/icons/steering-wheel.svg" width="60" /></i>
                                    </div>
                                    <h2 className="">1345</h2>
                                    <p>
                                        Drivers Registered
                                    </p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <div className="home-section3-grid text-center">
                                    <div className="dark-cyan-border circle">
                                        <i><img src="assets/images/icons/users.svg" width="60" /></i>
                                    </div>
                                    <h2 className="">2276</h2>
                                    <p>
                                        Helpers Registered
                                    </p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <div className="home-section3-grid text-center">
                                    <div className="sunset-orange-border circle">
                                        <i><img src="assets/images/icons/briefcase.svg" width="60" /></i>
                                    </div>
                                    <h2 className="">1347</h2>
                                    <p>
                                        JOBs Posted
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row hide">
                            <div className="col-md-12 text-center p-t-20">
                                <Link to={{
                                    pathname: '/registration-claimrepair',
                                    state: { subscription_id: 5, amount: 0 }
                                }} className="page-btn bg-red">BECOME A MEMBER NOW (It's FREE!)</Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="subscription-wrap text-center">
                    <div className="subscription-overlay p-t-40 p-b-60">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 p-b-40">
                                    <h2 className="m-0 text-center common-title f-s-35 text-semi-bold">Subscription Plans</h2>
                                </div>

                                <div className="col-md-4 col-sm-6 col-md-offset-2">
                                    <div className="pricing text-center">
                                        <div className="pricing-header bg-gradient-blue">
                                            <h6 className="pricing-title m-0">Free Membership</h6>
                                        </div>
                                        <div className="pricing-body">
                                            <div className="pricing-price text-blue p-t-20">
                                                <span className="pricing-currency">$</span> 0 <span>/mo</span>
                                            </div>
                                            <ul className="pricing-list">
                                                <li>Access our database of :<br />
                                                    1,000+ Helpers<br />
                                                    2,500+ Movers.
                                                </li>
                                                <li> <b>Exclusive discounts on hundreds of products and services:</b>
                                                    <br /> Truck Rental,<br /> Packing Material, <br />Hotels, <br />Fuel, <br />Moving Equipment and more.
                                                </li>
                                                <li>Post your availability to get <b>more side jobs</b></li>

                                                <li>Find Truck Parking.</li>
                                                <li>Manage your Schedule.</li>
                                                <li>Roadside Service.</li>
                                            </ul>
                                        </div>
                                        <div className="pricing-footer p-t-20 p-b-20">
                                            <Link to={{
                                                pathname: '/registration-claimrepair',
                                                state: { subscription_id: 5, amount: 0 }
                                            }} className="pricing-footer-bg-blue">Select</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6">
                                    <div className="pricing text-center">
                                        <div className="pricing-header bg-gradient-pink">
                                            <p>popular</p>
                                            <h5 className="pricing-title m-0">Pro</h5>
                                            <div className="offer">
                                                <span>50%</span>
                                                <b>OFF</b>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <div className="pricing-price text-pink p-t-20">
                                                <span className="pricing-currency">$</span> 15 <span>/mo</span>
                                                <p>All benefits of free membership</p>
                                                <i><img src="assets/images/icons/pink/add.svg" width="20" /></i>
                                            </div>
                                            <ul className="pricing-list">
                                                <li>
                                                    Reduce claims by 90% with MyReloPro's unique technology.

                                                </li>
                                                <li>Find More Shipments</li>
                                                <li>Chat with Movers, Customers, ReloPros and all other MyRelo Members.
                                                </li>
                                                <li>$$ Make it easy to receive tips $$. </li>
                                                <li>Pay your helpers through the App.</li>
                                            </ul>
                                        </div>
                                        <div className="pricing-footer p-t-20 p-b-20">
                                            <Link to={{
                                                pathname: '/registration-claimrepair',
                                                state: { subscription_id: 6, amount: 15 }
                                            }} className="pricing-footer-bg-pink">Select</Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Content;